import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "background"]

  open() {
    this.sidebarTarget.classList.add('mobile-menu--open')
    this.backgroundTarget.classList.add('mobile-menu-background--open')
  }

  close() {
    this.sidebarTarget.classList.remove('mobile-menu--open')
    this.backgroundTarget.classList.remove('mobile-menu-background--open')
  }
} 